import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { EpubReaderView } from 'src/components/material/reader/epubFoliateAdapter';
import { FixtureReaderPage } from 'src/components/material/reader/FixtureReaderPage';
import epubFixtureUrl from 'src/components/material/reader/fixtures/alice.epub?url';

import type { ReaderDocument } from 'src/components/material/reader/types';

/**
 * EPUB showcase: the shell driving the Foliate adapter against the bundled
 * "Alice's Adventures in Wonderland" fixture (public domain).
 *
 * Unauthenticated on purpose — see `FixtureReaderPage` for why.
 */
const EpubMaterialReaderPage = () => {
  const epubDocument = useMemo<ReaderDocument>(
    () => ({
      id: 'fixture-epub-alice',
      kind: 'epub',
      title: "Alice's Adventures in Wonderland",
      source: { kind: 'url', url: epubFixtureUrl },
    }),
    []
  );

  return <FixtureReaderPage document={epubDocument} View={EpubReaderView} />;
};

export const Route = createFileRoute('/reader/epub')({
  component: EpubMaterialReaderPage,
});
